"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var camelcaseKeysDeep = require('camelcase-keys-deep');
var RateType = /** @class */ (function () {
    function RateType(data) {
        data = camelcaseKeysDeep(data);
        this.id = data.id;
        this.name = data.name;
    }
    return RateType;
}());
exports.RateType = RateType;
